<template>
  <div class="geo-layer-manager">
    <v-card>
      <v-card-title class="text-subtitle-1">
        Importierte Layer
        <v-spacer></v-spacer>
        <v-btn icon @click="isOpen = !isOpen">
          <v-icon>{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
        </v-btn>
      </v-card-title>

      <v-expand-transition>
        <div v-if="isOpen">
          <v-list dense>
            <v-list-item v-if="layers.length === 0">
              <v-list-item-title>Keine Layer importiert</v-list-item-title>
            </v-list-item>

            <v-list-item v-for="layer in layers" :key="layer.id">
              <template v-slot:default>
                <v-list-item-title>{{ layer.name }}</v-list-item-title>
              </template>

              <template v-slot:append>
                <v-btn icon small @click="editLayerStyle(layer)" class="mr-2">
                  <v-icon small>mdi-palette</v-icon>
                </v-btn>

                <v-switch
                  :model-value="layer.visible"
                  @update:model-value="(value) => toggleLayer(layer.id, value)"
                  dense
                  hide-details
                ></v-switch>

                <v-btn icon small @click="removeLayer(layer.id)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-list-item>
          </v-list>
        </div>
      </v-expand-transition>
    </v-card>

    <!-- Style Editor Dialog -->
    <v-dialog v-model="styleDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h6">Layer Style bearbeiten</span>
        </v-card-title>
        <v-card-text>
          <geo-package-style-editor
            v-if="selectedLayer"
            :style="selectedLayer.style || {}"
            :geometry-type="selectedLayer.geometryType || 'Unknown'"
            :layer-id="selectedLayer.id"
            @update:style="updateLayerStyle"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" variant="text" @click="styleDialog = false">
            Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from "vue";
import GeoPackageStyleEditor from "./GeoPackageStyleEditor.vue";
import { GeoPackageStyle } from "@/utils/geopackage-style-utils";
import { JmApi } from "@/jm-api/jm-api";

export default defineComponent({
  name: "GeoPackageLayerManager",
  components: {
    GeoPackageStyleEditor,
  },

  props: {
    layers: {
      type: Array as PropType<
        {
          id: string;
          name: string;
          visible: boolean;
          style?: GeoPackageStyle;
          geometryType?: string;
        }[]
      >,
      required: true,
    },
  },

  data() {
    return {
      isOpen: false,
      styleDialog: false,
      selectedLayer: null as {
        id: string;
        name: string;
        visible: boolean;
        style?: GeoPackageStyle;
        geometryType?: string;
      } | null,
    };
  },

  methods: {
    toggleLayer(layerId: string, visible: boolean) {
      this.$emit("toggle-layer", layerId, visible);
    },

    removeLayer(layerId: string) {
      this.$emit("remove-layer", layerId);
    },

    editLayerStyle(layer: {
      id: string;
      name: string;
      visible: boolean;
      style?: GeoPackageStyle;
      geometryType?: string;
    }) {
      //console.log("[GeoPackageLayerManager] editLayerStyle called");
      //console.log("[GeoPackageLayerManager] layer:", layer);
      //console.log("[GeoPackageLayerManager] layer.style:", layer.style);
      //console.log("[GeoPackageLayerManager] layer.geometryType:", layer.geometryType);

      this.selectedLayer = { ...layer };
      //console.log("[GeoPackageLayerManager] selectedLayer:", this.selectedLayer);

      this.styleDialog = true;
    },

    updateLayerStyle(newStyle: GeoPackageStyle) {
      if (!this.selectedLayer) return;

      // Update the style in local state
      this.selectedLayer.style = newStyle;

      // Emit event to update parent components
      this.$emit("update-layer-style", this.selectedLayer.id, newStyle);

      // Close dialog
      this.styleDialog = false;
    },
  },
});
</script>

<style scoped>
.geo-layer-manager {
  position: absolute;
  bottom: 20px;
  left: 10px;
  width: 300px;
  z-index: 1000;
  opacity: 0.9;
}

.geo-layer-manager:hover {
  opacity: 1;
}
</style>
